module.exports = __webpack_public_path__ + "img/upi.f9deec97.svg";